const login = {
        title: String("Iniciar Sessió"),
        welcomeMsg: String("Benvingut a AgroUPAdvisor!"),
        credentialAsk: String("Introduïu les vostres credencials"),
        rememberMe: String("Recordar les meves credencials"),
        signInButton: String("Iniciar Sessió"),
        forgotPass: String("Heu oblidat la contrasenya?"),
        createNewAccount: String("Crear un compte nou"),
        resendEmail: String("Re-enviar el correu electrònic de validació"),
        forgotPassTitle: String("Heu oblidat la contrasenya?"),
        forgotPassDescription: String("Introduïu el vostre correu electrònic i se us enviarà un correu perquè pugueu restaurar la vostra contrasenya."),
        forgotPassButton: String("Enviar correu"),
        cancelButton: String("Tancar"),
        emailAlreadySent: String("S'ha enviat un correu electrònic amb instruccions per recuperar la contrasenya."),
        username: String("Nom d'usuari"),
        password: String("Contrasenya"),
        email: String("Correu electrònic"),
        errorFieldRequired: String("Aquest camp és obligatori"),
        errorInvalidLength: String("Nombre de caràcters mínim: "),
        errorCredentials: String("L'usuari i/o la contrasenya són incorrectes."),
        errorFieldEmail: String("Adreça de correu electrònic es invalida."),
        adviceActiveAccount: String("Aquest compte encara no s'ha activat."),
        emailNotRegistered: String("L'adreça de correu electrònic no està associada a cap usuari."),
};

export default login;